import { ProcessingStreamEvent, PromptRun } from '../services/api';

/** The shared store orders document versions before delivering full snapshots. */
export const toPromptRunFromProcessingEvent = (
  event: ProcessingStreamEvent,
  existing?: PromptRun,
): PromptRun | null => {
  const snapshot = event.payload?.snapshot;
  if (event.event_type !== 'run.progress' || !snapshot?.run_id) return null;
  return {
    prompt_id: '', prompt_name: 'Extraction', prompt_type: 'custom', executed_by: '',
    executed_at: event.created_at || '', total_videos: 0, completed_videos: 0, failed_videos: 0,
    ...existing, ...snapshot,
    run_context: { ...existing?.run_context, ...snapshot.run_context, ...snapshot.target },
  };
};
